import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetPatientIdentityByIdRequest,
    GetPatientIdentityByIdResponse,
    type IReturn,
    type PatientIdentity,
    type ResponseStatus,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetPatientIdentityByIdResponse, GetPatientIdentityByIdResponse>,
) => response?.data?.patientIdentity;
const getError = (
    response?: SWRResponse<GetPatientIdentityByIdResponse, GetPatientIdentityByIdResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<GetPatientIdentityByIdResponse, GetPatientIdentityByIdResponse>,
) => ({});

const usePatientIdentityById = (
    id?: number | null,
    configuration?:
        | SWRConfiguration<GetPatientIdentityByIdResponse, GetPatientIdentityByIdResponse>
        | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetPatientIdentityByIdResponse> =>
            new GetPatientIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration ?? undefined);
};

export default usePatientIdentityById;
